/**
 * Tracks select_item event when a product is clicked
 * @param {HTMLElement} card - Product card element (Boost or regular)
 * @param {number} index - Product position in the list (1-based)
 * @param {string} listName - Name of the product list
 * @param {string|number} listId - ID of the product list
 */
const trackSelectItem = async (card, index, listName, listId) => {
  const EVENT_NAME_SELECT_ITEM = 'select_item';

  try {
    if (typeof window.dataLayer === 'undefined') {
      console.error(`${EVENT_NAME_SELECT_ITEM} - dataLayer not available.`);
      return;
    }

    const gtmItemData = await extractGtmDataFromCard(card);
    if (!gtmItemData) {
      console.error(`${EVENT_NAME_SELECT_ITEM} - Could not extract GTM data from card`);
      return;
    }

    const currency = window.gtmConfig?.currency;
    const item = {
      ...gtmItemData,
      index: index
    };

    window.dataLayer.push({
      event: EVENT_NAME_SELECT_ITEM,
      ecommerce: {
        currency: currency,
        item_list_id: String(listId),
        item_list_name: listName,
        items: [item]
      },
      _clear: true
    });

    console.info(`✓ GTM event ${EVENT_NAME_SELECT_ITEM} pushed to dataLayer.`);
  } catch (error) {
    console.error(`Error tracking ${EVENT_NAME_SELECT_ITEM}:`, error);
  }
}


const initProductClick = (attempts = 0) => {
  const maxAttempts = 50;
  const products = document.querySelectorAll('.boost-sd__product-item');
  if (products.length === 0) {
    if (attempts < maxAttempts) {
      setTimeout(() => initProductClick(attempts + 1), 100);
    }
    return;
  }

  const listName = window.gtmConfig?.listName || window.location.pathname;
  const listId = window.gtmConfig?.listId || '';

  products.forEach((productCard, index) => {
    productCard.addEventListener('click', function(e) {
      if (!e.target.closest('a')) return;
      
      trackSelectItem(productCard, index + 1, listName, listId);
    });
  });
};

window.onGtmReady(function() {
  initProductClick();
});
